<template>
  <UApp
    :toaster="{
      position: 'top-center',
      progress: false,
      ui: { viewport: 'auth-toast-viewport' },
    }"
  >
    <RouterView />
  </UApp>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { useAppStore } from '@/stores/app'
import { useAuthStore } from '@/stores/auth'

const appStore = useAppStore()
const authStore = useAuthStore()

onMounted(() => {
  appStore.applyPreferences()
  authStore.init()
})
</script>

<style>
@media (min-width: 881px) {
  html:has(.auth-layout) .auth-toast-viewport {
    top: 88px;
    left: 72.5%;
  }
}
</style>
